module.exports = __webpack_public_path__ + "static/media/6.db33c1a3.svg";